import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBraces = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.44444 4H7.55556C7.08406 4 6.63187 4.1873 6.29848 4.5207C5.96508 4.8541 5.77778 5.30628 5.77778 5.77778V10.2222C5.77778 10.6937 5.59048 11.1459 5.25708 11.4793C4.92368 11.8127 4.4715 12 4 12C4.4715 12 4.92368 12.1873 5.25708 12.5207C5.59048 12.8541 5.77778 13.3063 5.77778 13.7778V18.2222C5.77778 19.2 6.57778 20 7.55556 20H8.44444M15.5556 20H16.4444C16.9159 20 17.3681 19.8127 17.7015 19.4793C18.0349 19.1459 18.2222 18.6937 18.2222 18.2222V13.7778C18.2222 12.8 19.0222 12 20 12C19.5285 12 19.0763 11.8127 18.7429 11.4793C18.4095 11.1459 18.2222 10.6937 18.2222 10.2222V5.77778C18.2222 5.30628 18.0349 4.8541 17.7015 4.5207C17.3681 4.1873 16.9159 4 16.4444 4H15.5556",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBraces);
export { ForwardRef as ReactComponent };
